import actions from './actions';
import reducers from './reducers';
import selectors from './selectors';

export default {
  actions,
  reducers,
  selectors,
};
